import {
  RequestorId,
  ShippingCalculator,
  Locale as ShippingCalculatorLocale,
} from "@vp/shipping-calc-components";
import React, { useContext } from "react";

import { IdentityContext } from "../../../contexts/IdentityProvider";
import { PricingContext } from "../../../contexts/PricingContext";
import { PageStaticDataContext } from "../../../contexts/PageStaticDataContextProvider";
import { ProductContext } from "../../../contexts/ProductContextProvider";
import { AnalyticsContext } from "../../../contexts/AnalyticsContextProvider";
import PageConfig from "../../../utils/PageConfig";
import { Box } from "@vp/swan";
import "@vp/shipping-calc-components/style.css";

type ShippingCalculatorBuilderProps = {};

const ShippingCalculatorBuilder = (props: ShippingCalculatorBuilderProps) => {
  const tenant = PageConfig.tenant;
  const { isIdentityInitialized } = useContext(IdentityContext);
  const { selectedQuantity, selections } = useContext(ProductContext);
  const { vistacartTenant, locale, mpv } = useContext(PageStaticDataContext);

  const { analyticsPageName } = useContext(AnalyticsContext);
  const { vatInclusivity } = useContext(PricingContext);

  if (!isIdentityInitialized || !vistacartTenant?.tenantId || !selections) {
    return <></>;
  }

  return (
    <Box mb={"3"}>
      <ShippingCalculator
        clientConfiguration={{
          requestor: "Product Page",
          requestorId: RequestorId.CorePDP,
        }}
        userConfiguration={{
          vatInclusivity: vatInclusivity,
        }}
        tenantConfiguration={{
          locale: locale as ShippingCalculatorLocale,
          tenant: tenant,
          tenantId: vistacartTenant.tenantId,
        }}
        productConfiguration={{
          productKey: mpv.coreProductId,
          productQuantity: selectedQuantity,
          productSelections: selections,
          productVersion: mpv.version,
        }}
        trackingData={{
          category: "Product Page",
          pageSection: "Product Builder",
          pageStage: "Discover",
          pageName: analyticsPageName(mpv.mpvId),
        }}
      />
    </Box>
  );
};

export default ShippingCalculatorBuilder;
